import { render, staticRenderFns } from "./HomePageMessages.vue?vue&type=template&id=29f3f020&scoped=true&"
import script from "./HomePageMessages.vue?vue&type=script&lang=js&"
export * from "./HomePageMessages.vue?vue&type=script&lang=js&"
import style0 from "./HomePageMessages.vue?vue&type=style&index=0&id=29f3f020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f3f020",
  null
  
)

export default component.exports